import React from 'react';
import PropTypes from 'prop-types';
import { SnackbarContent } from '@material-ui/core';
import Fade from '@material-ui/core/Fade';
import Grow from '@material-ui/core/Grow';
import Slide from '@material-ui/core/Slide';
import Snackbar from '@material-ui/core/Snackbar';

import { generateID } from 'utils/helpers';

import styles from './SnackbarWrapper.css';


const IDS = {
  prefix: '6wUbHMrj',
  element: 'Snackbar',
  closeSnackbar: 'closeSnackbar',
  messageContentId: 'messageContentId',
};

const makeId = generateID(IDS.prefix, IDS.element);

const themeColor = {
  default: styles.default,
  success: styles.success,
  error: styles.error,
};

const transitionMapping = {
  slide: Slide,
  grow: Grow,
  fade: Fade,
};

function SnackbarWrapper(props) {
  const {
    action,
    actionClass,
    anchorOrigin,
    autoHideDuration,
    className,
    message,
    messageClass,
    messageContentId,
    open,
    subtype,
    transition,
    onClose,
  } = props;

  const Comp = action;
  const contentId = messageContentId || makeId(IDS.messageContentId);

  return (
    <Snackbar
      ContentProps={{ 'aria-describedby': contentId }}
      TransitionComponent={transitionMapping[transition]}
      action={
        action && (
          <div className={actionClass}>
            <Comp onClose={onClose} />
          </div>
        )
      }
      anchorOrigin={anchorOrigin}
      autoHideDuration={autoHideDuration}
      className={`${themeColor[subtype]} ${className}`}
      message={
        typeof message === 'string' ? (
          <div id={messageContentId || makeId(IDS.messageContentId)}>
            {message}
          </div>
        ) : (
          <SnackbarContent className={messageClass} message={message} />
        )
      }
      open={open}
      onClose={onClose}
    />
  );
}

SnackbarWrapper.propTypes = {
  action: PropTypes.oneOfType([PropTypes.node, PropTypes.element, PropTypes.func]),
  actionClass: PropTypes.string,
  anchorOrigin: PropTypes.shape({
    vertical: PropTypes.string,
    horizontal: PropTypes.string,
  }),
  autoHideDuration: PropTypes.number,
  className: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  messageClass: PropTypes.string,
  messageContentId: PropTypes.string,
  open: PropTypes.bool,
  subtype: PropTypes.string,
  transition: PropTypes.string,
  onClose: PropTypes.func,
};

SnackbarWrapper.defaultProps = {
  action: undefined,
  actionClass: undefined,
  anchorOrigin: undefined,
  autoHideDuration: undefined,
  className: undefined,
  message: undefined,
  messageClass: undefined,
  messageContentId: undefined,
  open: false,
  subtype: undefined,
  transition: undefined,
  onClose: () => undefined,
};

export default SnackbarWrapper;
